import { type IPersistentStorage } from '@webapp/infrastructure/interfaces/services/IPersistentStorage'
import { type IRecentConversationsRepository } from '../../business-logic/interfaces/IRecentConversationsRepository'
import { type RecentConversation } from '../../value-objects/RecentConversation'

const STORAGE_KEY = 'procurify.global-command.recent-conversations.v1'

interface StoredRecentConversations {
  conversations: RecentConversation[]
}

interface Dependency {
  storage: IPersistentStorage
}

export class RecentConversationsRepository implements IRecentConversationsRepository {
  constructor(private readonly deps: Dependency) {}

  getAll(): RecentConversation[] {
    const stored = this.deps.storage.get<StoredRecentConversations>(STORAGE_KEY)
    return stored?.conversations ?? []
  }

  save(conversations: RecentConversation[]): void {
    this.deps.storage.set<StoredRecentConversations>(STORAGE_KEY, {
      conversations,
    })
  }
}
